<!-- Table -->
 <div class="flex justify-center items-center my-6">
    <div class="card flex justify-center px-6">
        <p-table
          [value]="dataList"
          [lazy]="true"
          styleClass="custom-table"
        >
          <ng-template pTemplate="header">
            <tr class="poppins-medium bg-[#D9CFFF]">
              <th pSortableColumn="metric">Metric</th>
              <th pSortableColumn="value">Value</th>
            </tr>
          </ng-template>

          <!-- Body Template -->
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr class="odd">
              <td>Total Books Entries</td>
              <td class="even-column">{{ rowData.totalBooksEntries }}</td>
            </tr>
            <tr>
              <td>Total GSTR2B Entries</td>
              <td class="even-column">{{ rowData.totalGSTR2BEntries }}</td>
            </tr>
            <tr class="odd">
              <td>Matched Books Entries</td>
              <td class="even-column">{{ rowData.matchedBooksEntries }}</td>
            </tr>
            <tr >
              <td>Matched GSTR2B Entries</td>
              <td class="even-column">{{ rowData.matchedGSTR2BEntries }}</td>
            </tr>
            <tr class="odd">
              <td>Unmatched Books Entries</td>
              <td class="even-column">{{ rowData.unmatchedBooksEntries }}</td>
            </tr>
            <tr >
              <td>Unmatched GSTR2B Entries</td>
              <td class="even-column">{{ rowData.unmatchedGSTR2BEntries }}</td>
            </tr>
            <tr class="odd">
              <td>Books Match Percentage</td>
              <td class="even-column">{{ rowData.booksMatchPercentage }}</td>
            </tr>
            <tr >
              <td>GSTR2B Match Percentage</td>
              <td class="even-column">{{ rowData.gstr2BMatchPercentage }}</td>
            </tr>
          </ng-template>

          <!-- Empty Data Template -->
          <ng-template pTemplate="empty">
            <tr>
              <td colspan="2" class="text-center">No Data Found</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
 </div>


